import React, { useState } from "react";
import styled from "styled-components";
import { Divider, Form, Row, Col } from "antd";
import { RAButtonPrimary, RACheckbox, RATextInput } from "@/components/customs";
import { RASelectCountry, RASelectUSStates } from "@/components/atoms";
import { US_SHORT_CODE } from "@/config/constants";
const initSignupValues = {
	email: "",
	first_name: "",
	last_name: "",
	phone: "",
	password: "",
	confirm_password: "",
	address: {
		address: "",
		address2: "",
		country: {},
		city: "",
		state: "",
		zip_code: "",
	},
	settings: {
		time_format: "TWELVE_HOURS_FORMAT",
	},
	verify: false,
};

const InputProfileTemplate = ({ onFinish, onPressLogin, errors = {}, setErrors, loading }) => {
	const [signUpForm, setSignUpForm] = useState(initSignupValues);
	return (
		<SignUpTemplateSection>
			<Form layout="vertical" className="form-login-wrapper">
				<FormInputWrapper>
					<TitleText>Sign Up</TitleText>
					<Divider />
					<Row gutter={20}>
						<Col xl={12} lg={12} md={24} sm={24} xs={24}>
							<Form.Item name="firstname" requiredMark="optional">
								<RATextInput
									title="First name"
									placeholder="Enter your first name"
									onChange={(val) => {
										setSignUpForm({
											...signUpForm,
											first_name: val,
										});
										if (errors && errors.first_name) {
											delete errors.first_name;
											setErrors(errors);
										}
									}}
									error={errors?.first_name}
								/>
							</Form.Item>
						</Col>
						<Col xl={12} lg={12} md={24} sm={24} xs={24}>
							<Form.Item name="lastname" requiredMark="optional">
								<RATextInput
									title="Last name"
									placeholder="Enter your last name"
									onChange={(val) => {
										setSignUpForm({
											...signUpForm,
											last_name: val,
										});
										if (errors && errors.last_name) {
											delete errors.last_name;
											setErrors(errors);
										}
									}}
									error={errors?.last_name}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={20}>
						<Col xl={12} lg={12} md={24} sm={24} xs={24}>
							<Form.Item name="email" requiredMark="optional">
								<RATextInput
									title="Email"
									placeholder="Enter your email"
									onChange={(val) => {
										setSignUpForm({
											...signUpForm,
											email: val,
										});
										if (errors && errors.email) {
											delete errors.email;
											setErrors(errors);
										}
									}}
									error={errors?.email}
								/>
							</Form.Item>
						</Col>
						<Col xl={12} lg={12} md={24} sm={24} xs={24}>
							<Form.Item name="phone" requiredMark="optional">
								<RATextInput
									title="Phone"
									placeholder="Enter phone number"
									onChange={(val) => {
										setSignUpForm({
											...signUpForm,
											phone: val,
										});
										if (errors && errors.phone) {
											delete errors.phone;
											setErrors(errors);
										}
									}}
									onCountryChange={() => {}}
									type="phone"
									country="US"
									error={errors?.phone}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Form.Item name="password" requiredMark="optional">
						<RATextInput
							title="Password"
							placeholder="Enter your password"
							type="password"
							onChange={(val) => {
								setSignUpForm({
									...signUpForm,
									password: val,
								});
								if (errors && errors.password) {
									delete errors.password;
									setErrors(errors);
								}
							}}
							error={errors?.password}
						/>
					</Form.Item>
					<Form.Item name="confirm_password" requiredMark="optional">
						<RATextInput
							title="Confirm Password"
							placeholder="Enter confirm password"
							type="password"
							onChange={(val) => {
								setSignUpForm({
									...signUpForm,
									confirm_password: val,
								});
								if (errors && errors.confirm_password) {
									delete errors.confirm_password;
									setErrors(errors);
								}
							}}
							error={errors?.confirm_password}
						/>
					</Form.Item>
					<Form.Item name={["address", "address"]} requiredMark="optional">
						<RATextInput
							title="Address Line 1"
							placeholder="Enter Address Line 1"
							onChange={(val) => {
								setSignUpForm({
									...signUpForm,
									address: {
										...signUpForm.address,
										address: val,
									},
								});
								if (errors && errors.address?.address) {
									delete errors.address.address;
									setErrors(errors);
								}
							}}
							error={errors?.address?.address}
						/>
					</Form.Item>
					<Form.Item name={["address", "address2"]} requiredMark="optional">
						<RATextInput
							title="Address Line 2"
							placeholder="Enter Address Line 2"
							onChange={(val) => {
								setSignUpForm({
									...signUpForm,
									address: {
										...signUpForm.address,
										address2: val,
									},
								});
								if (errors && errors.address?.address2) {
									delete errors.address.address2;
									setErrors(errors);
								}
							}}
							error={errors?.address?.address2}
						/>
					</Form.Item>
					<Row gutter={20}>
						<Col xl={12} lg={12} md={24} sm={24} xs={24}>
							<Form.Item name={["address", "country"]} requiredMark="optional">
								<RASelectCountry
									title="Country"
									onChange={(val) => {
										setSignUpForm({
											...signUpForm,
											address: {
												...signUpForm.address,
												country: val,
												state: "",
											},
										});
										if (errors && errors.address?.country) {
											delete errors.address.country;
											setErrors(errors);
										}
									}}
									error={errors?.address?.country}
								/>
							</Form.Item>
						</Col>
						<Col xl={12} lg={12} md={24} sm={24} xs={24}>
							<Form.Item name={["address", "city"]} requiredMark="optional">
								<RATextInput
									title="City"
									placeholder="Enter City"
									onChange={(val) => {
										setSignUpForm({
											...signUpForm,
											address: {
												...signUpForm.address,
												city: val,
											},
										});
										if (errors && errors.address?.city) {
											delete errors.address.city;
											setErrors(errors);
										}
									}}
									error={errors?.address?.city}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={20}>
						<Col xl={12} lg={12} md={24} sm={24} xs={24}>
							<Form.Item name={["address", "state"]} requiredMark="optional">
								{signUpForm.address.country?.short_code === US_SHORT_CODE ? (
									<RASelectUSStates
										title="State"
										value={signUpForm?.address?.state}
										onChange={(val) => {
											setSignUpForm({
												...signUpForm,
												address: {
													...signUpForm.address,
													state: val,
												},
											});
											if (errors && errors.address?.state) {
												delete errors.address?.state;
												setErrors(errors);
											}
										}}
										error={errors?.address?.state}
									/>
								) : (
									<RATextInput
										title="State"
										placeholder="Enter State"
										onChange={(val) => {
											setSignUpForm({
												...signUpForm,
												address: {
													...signUpForm.address,
													state: val,
												},
											});
											if (errors && errors.address?.state) {
												delete errors.address.state;
												setErrors(errors);
											}
										}}
										error={errors?.address?.state}
									/>
								)}
							</Form.Item>
						</Col>
						<Col xl={12} lg={12} md={24} sm={24} xs={24}>
							<Form.Item name={["address", "zip_code"]} requiredMark="optional">
								<RATextInput
									title="Zip Code"
									placeholder="Enter Zip Code"
									onChange={(val) => {
										setSignUpForm({
											...signUpForm,
											address: {
												...signUpForm.address,
												zip_code: val,
											},
										});
										if (errors && errors.address?.zip_code) {
											delete errors.address.zip_code;
											setErrors(errors);
										}
									}}
									error={errors?.address?.zip_code}
								/>
							</Form.Item>
						</Col>
					</Row>

					<Row>
						<RACheckbox
							checked={signUpForm.verify}
							numRows={3}
							title="By continuing, you may receive an SMS for verification. Message and data rates may apply."
							onChange={() =>
								setSignUpForm({
									...signUpForm,
									verify: !signUpForm.verify,
								})
							}
						/>
					</Row>

					<WrapperBottom justify="center">
						<RAButtonPrimary
							title="SIGN UP"
							disabled={!signUpForm.verify}
							width="180px"
							loading={loading}
							onClick={() => {
								if (signUpForm.verify) {
									onFinish?.(signUpForm);
								}
							}}
						/>
						<Row>
							<ForgotPasswordText>Already have an account?</ForgotPasswordText>
							<SignUpText onClick={() => onPressLogin?.()}>Log-in now</SignUpText>
						</Row>
					</WrapperBottom>
				</FormInputWrapper>
			</Form>
		</SignUpTemplateSection>
	);
};

const SignUpTemplateSection = styled.div`
	padding-top: 30px;
	padding-bottom: 30px;
	width: 50vw;
	max-width: 620px;
	min-width: 343px;
	padding: clamp(24px, 8vw, 60px) clamp(16px, 4vw, 60px);
`;
const FormInputWrapper = styled.div`
	align-self: center;
`;
const TitleText = styled.div`
	font-family: "Gilda Display";
	font-style: normal;
	font-weight: 400;
	font-size: 24px;
	line-height: 28px;
	text-transform: capitalize;
	color: #121216;
	margin-bottom: 20px;
	padding-left: 20px;
	border-left: 2px solid #ffb11a;
`;
const WrapperBottom = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin-top: 30px;
	gap: 12px;
`;
const SignUpText = styled.div`
	font-family: "DM Sans";
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 18px;
	display: flex;
	align-items: center;
	color: ${(props) => props.color || "#ffb11a"};
	padding-left: 4px;
	cursor: pointer;
`;
const ForgotPasswordText = styled.div`
	font-family: "DM Sans";
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 18px;
	display: flex;
	align-items: center;
	color: #222222;
`;

export { InputProfileTemplate };
